import { RootStore, RootStoreModel } from "../models/root-store/root-store"

// eslint-disable-next-line @typescript-eslint/no-empty-function
export let getRootStore: () => RootStore = () => RootStoreModel && RootStoreModel.create({})

export const setRootStore = (rootStore) => {
  getRootStore = () => rootStore
}
